/*jshint esversion:6*/
import React, { Component } from 'react';
import ProjectCardImage from "./ProjectCardImage";
import ProjectCardContent from './ProjectCardContent';
import "../styles/ProjectCard.css";

export default class ProjectCard extends Component {
    /*jshint ignore:start*/
    render() {
        return (
            <div style={{flexDirection:this.props.direction}} className = "projectCard" >
                <ProjectCardImage source={this.props.source} alt={this.props.alt} />
                <ProjectCardContent linkAlign={this.props.direction==='row'?'flex-start':'flex-end'}
                                    projectName={this.props.projectName}
                                    projectDescription={this.props.projectDescription}
                                    projectSrc = {this.props.projectSrc}
                                    projectDemoSrc = {this.props.projectDemoSrc}/>
            </div>
        )
    }
    /*jshint ignore:end*/
}
